import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=b2ed3128&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=b2ed3128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ed3128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2ed3128')) {
      api.createRecord('b2ed3128', component.options)
    } else {
      api.reload('b2ed3128', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=b2ed3128&scoped=true&", function () {
      api.rerender('b2ed3128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8NcUdKRGtx5ed/JS/comp/DocBox.vue"
export default component.exports